<template>
  <vs-popup
    id="report-approval-dialog"
    :active.sync="showDialog"
    :title="title"
    :button-close-hidden="true"
  >
    <div>
      <vs-row vs-w="12">
        <vs-col vs-justify="flex-start" vs-align="center" vs-w="4">
          <div class="aisea-text-14-600-black">船舶名</div>
          <div>{{ this.vesselName }}</div>
        </vs-col>
        <vs-col vs-justify="flex-start" vs-align="center" vs-w="6">
          <div class="aisea-text-14-600-black">送信者</div>
          <div>{{ this.reportSender.name }}</div>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col
          vs-justify="center"
          vs-align="center"
          vs-w="12"
          class="mt-8 mb-8"
        >
          <div class="aisea-text-16-400-gray">コメント</div>
          <vs-textarea
            placeholder="コメントを書く…"
            :counter="maxLengthComment"
            :counter-danger.sync="counterDanger"
            v-model="comment"
          />
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="12"
        >
          <vs-button
            class="mr-2"
            :color="AISEA_COLOR.BLUE"
            :disabled="counterDanger"
            @click="onClickPostApproval()"
            >{{ action }}
          </vs-button>
          <vs-button :color="AISEA_COLOR.BLUE" type="border" @click="cancel()"
            >キャンセル
          </vs-button>
        </vs-col>
      </vs-row>
    </div>
  </vs-popup>
</template>

<script>
import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";
import { debounce } from "lodash";

const { mapState, mapActions, mapGetters } = createNamespacedHelpers(
  "vesselNoonReportDetail"
);

export default {
  mixins: [DeviceInfoMixin, ColorMixin],
  data() {
    return {
      showDialog: false,
      transaction: null,
      comment: "",
      maxLengthComment: 255,
      counterDanger: false,
    };
  },
  computed: {
    ...mapState(["workflowStatus", "version", "vesselDetail"]),
    ...mapGetters(["vesselName", "reportSender"]),
    title() {
      if (!this.transaction) return "";
      return `動静連絡を${this.transaction.label}`;
    },
    action() {
      if (!this.transaction) return "";
      return this.transaction.label;
    },
  },
  methods: {
    ...mapActions(["setReportTransaction", "getReportDetail"]),

    onClickPostApproval() {
      this.clickPostApproval(this);
    },

    clickPostApproval: debounce(async self => {
      self.$vs.loading();
      const payload = {
        vesselId: self.$route.params.vesselId,
        reportId: self.$route.params.reportId,
        transactionId: self.transaction.id,
        requestBody: {
          version: self.version + 1,
          comment: self.comment,
        },
        actionName: self.action,
      };

      try {
        await self.setReportTransaction(payload);
        await self.getReportDetail(payload);

        setTimeout(async () => {
          self.$vs.loading.close();
          await self.$router.push({
            name: "addon-vessel-noon-report-list",
          });
          self.close();
          self.$vs.notify({
            title: `${self.action}が完了しました。`,
            color: "success",
            iconPack: "feather",
            icon: "icon-check",
          });
        }, 1000);
      } catch (error) {
        self.$vs.loading.close();
        self.$vs.notify({
          title: `${self.action}失敗`,
          text: `${error.msg}画面を再読み込みしてください。`,
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
    }, 500),

    show(transaction) {
      this.showDialog = true;
      this.transaction = transaction;
    },

    cancel() {
      this.close();
    },

    close() {
      this.showDialog = false;
      this.comment = "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";

#report-approval-dialog {
  --vs-primary: 3, 155, 229;
}
</style>
